import { Component, OnInit, inject } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';
import { FormBuildersService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  CustomResultOfPaginatedListOfGetFormBuildersWithPaginationDto,
  GetFormBuildersWithPaginationDto,
} from '../../../core/api/models';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { GetEnumValuesDto } from './../../../core/api/models/get-enum-values-dto';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { FormsManagementFormComponent } from './forms-management-form/forms-management-form.component';
import { TextPopoverDirective } from 'src/app/core/directives/text-popover.directive';

@Component({
  selector: 'app-forms-management',
  templateUrl: './forms-management.component.html',
  imports: [BaseIndexModule, FormsManagementFormComponent,TextPopoverDirective],
})
export class FormsManagementComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.formsManagement;

  /* Binding service endpoints */
  protected currentService = inject(FormBuildersService);
  paginationApiMethodName: string =
    this.currentService.formBuildersGetFormBuildersWithPagination.name;

  /* Binding service endpoints */

  modelWithPagination$: Observable<CustomResultOfPaginatedListOfGetFormBuildersWithPaginationDto>;
  items$: Observable<Array<GetFormBuildersWithPaginationDto>>;
  formPageConfig: FormPageConfig<any> = {};

  //enums
  FormBuilderThemesEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAuditBtn = false;
  }

  getEnumsValues() {
    this.getEnumValuesApi('FormBuilderThemes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.FormBuilderThemesEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.title,
        name: 'title',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}theme`,
        name: 'theme',
        hasSearch: true,
        type: 'enum',
        enumName: 'FormBuilderThemes',
      },
      {
        title: this.localizer.description,
        name: 'description',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  override onCreate(type?: any, isFormModal?: boolean) {
    try {
      this.setParentQueryString();

      this.location.go(window.location.pathname + '?key-formType=create');
      this.pageConfig.isVisibleForm = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();
    this.pageConfig.loading = true;
    this.formPageConfig.editId = id;
    this.currentService
      .formBuildersUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .formBuildersDelete({ body: { id: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }
  //#endregion

  onShowPreview(id) {
    window.open('https://smsadmin.pishgamrayan.com/form/' + id, '_blank');
  }
}
